import React, { useState, useEffect } from "react";
import * as constantMessages from "../../../constants/constatntMessages";

// Admin Registration FILTER COMPONENT
const FilterComponent = (props) => {
  const [errors, setErrors] = useState({});
  const [searchData, setSearchData] = useState({ fromDate: "", toDate: "" });
  const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
      setSearchData({ ...props.initData });
    }, [props.initData]);
  
    useEffect(() => {
      setIsDisabled(!(searchData.fromDate || searchData.toDate));
    }, [searchData]);
   
    useEffect(() => {
    }, [searchData]);

  const validateDates = () => {
    const errors = {};
    if (searchData.fromDate && searchData.toDate) {
      if (new Date(searchData.fromDate) > new Date(searchData.toDate)) {
        errors.fromDate = constantMessages.invalidFromDate;
      }
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData({
      ...searchData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateDates()) return;

    props.setfilter(false);
    props.filterData(searchData);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setSearchData({
      fromDate: "",
      toDate: "",
      page: 1, // Ensure page resets
    });
    props.filterData({
      fromDate: "",
      toDate: "",
      page: 1,
    });
  };

  return (
    <div
      className={props.filter ? "filter show" : "filter"}
      id="form-container"
    >
      <div className="filter-container">
        <h4 className="filterheading mb-0">Filter Organizations</h4>
        <button
          type="button"
          onClick={(e) => props.setfilter(false)}
          style={{ border: "none", padding: 0, margin: 0 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </button>
      </div>

      <form id="myForm" onSubmit={handleSubmit} className="filter-form">
        <label htmlFor="from">From Date</label>
        <div className="from-to">
          <input
            className="filter-date"
            type="date"
            id="from"
            name="fromDate"
            value={searchData.fromDate}
            onChange={handleChange}
            onBlur={validateDates}
          />
        </div>
        {errors.fromDate && (
          <span className="error-message">{errors.fromDate}</span>
        )}

        <label htmlFor="to">To Date</label>
        <div className="from-to">
          <input
            className="filter-date"
            type="date"
            id="to"
            name="toDate"
            value={searchData.toDate}
            onChange={handleChange}
            onBlur={validateDates}
          />
        </div>

        <div className="mt-2 form-btm-btn">
          <button className="reset" type="reset" onClick={handleReset}>
            <p>Reset</p>
          </button>
          <button className="add-btn Mom-btn" disabled={isDisabled}>
            <p>Filter</p>
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterComponent;
